module.exports = __webpack_public_path__ + "img/E309.aae88ecb.svg";